import { DateTimeFactory } from "../../../../localization/useDateTime"
import { PriceListType } from "../../priceList/priceListApi"
import { ProductGroup, ProductGroupFormValues } from "../productGroupTypes"

export const prepareInitialValues = (
    dateTimeFactory: DateTimeFactory,
    productGroup?: ProductGroup,
    defaultPriceList?: PriceListType | null,
): ProductGroupFormValues => {
    const timeIntervalStart = dateTimeFactory.fromISO(productGroup?.availabilityDetails?.timeInterval?.start ?? "10:00")
    const timeIntervalEnd = dateTimeFactory.fromISO(productGroup?.availabilityDetails?.timeInterval?.end ?? "12:00")

    return {
        name: productGroup?.name ?? "",
        isActive: productGroup?.isActive ?? true,
        productGroupCode: productGroup?.productGroupCode ?? undefined,
        // priceLists: productGroup?.priceLists?.map((pl) => ({ id: pl.id, name: pl.name, isActive: true })) ?? [],
        priceList: productGroup?.priceLists?.[0]
            ? { id: productGroup.priceLists[0].id, name: productGroup.priceLists[0].name, isActive: true }
            : (defaultPriceList ?? null),
        availableTime: productGroup?.availabilityDetails !== undefined,
        weekDays: productGroup?.availabilityDetails?.weekDays ?? [],
        timeIntervalStart,
        timeIntervalEnd,
        isLocked: productGroup?.securitySettings?.isLocked ?? false,
    }
}
